import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Typography, Container } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
export const ErrorPageContent = (props) => {
    const { header, body, ...rest } = props;
    return (_jsxs(Container, { ...rest, children: [_jsx(Typography, { variant: "h5", gutterBottom: true, children: header }), body] }));
};
export const ErrorPage = ({ error }) => {
    const status = error?.response?.status ?? error.statusCode;
    let header = (_jsx(FormattedMessage, { id: "dploy.error.default", defaultMessage: "An error has occured" }));
    let body = undefined;
    /* eslint-disable react-hooks/rules-of-hooks */
    if (process.env.NODE_ENV === "development") {
        const isHtml = error.response?.headers
            .get("Content-Type")
            ?.includes("html");
        const [html, setHtml] = useState();
        useEffect(() => {
            if (!isHtml || error.response.bodyUsed)
                return;
            let active = true;
            (async () => {
                const text = await error.response.text();
                if (active)
                    setHtml(text);
            })();
            return () => {
                active = false;
            };
        }, [error, isHtml]);
        body = (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "pre", variant: "caption", color: "error", gutterBottom: true, children: error.stack }), html && (_jsx("iframe", { frameBorder: 0, srcDoc: html, width: "100%", height: "800px", title: "Network error response" }))] }));
    }
    /* eslint-disable react-hooks/rules-of-hooks */
    if (status) {
        header = (_jsx(FormattedMessage, { id: "dploy.error.status", defaultMessage: "{status}: {status, select, 401 {No access} 403 {No access} 404 {Not found} other {An error has occurred}}", values: { status } }));
    }
    return _jsx(ErrorPageContent, { header: header, body: body });
};
//# sourceMappingURL=ErrorPage.js.map